const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowMyOffers', [require('./my-offers-directive')]);
wowApp.service('CompetitionService', ['Restangular', 'AtmService', 'AtmLocalService', '$state', require('./competition-service')]);
wowApp.service('ShopperMarketingService', ['Restangular', require('../../../../src/myaccount/components/myaccount/shopper-marketing-service')]);

wowApp.directive('wowCompetition', [
    '$state',
    '$rootScope',
    'AgeCalculatorService',
    'SettingsService',
    'ShopperService',
    'ShopperMarketingService',
    'BreakpointsService',
    'GlobalHeaderPanelService',
    'CurrentUserService',
    'CompetitionService',
    '$stateParams',
    '$sce',
    '$timeout',
    'SignupService',
    'AtmService',
    'GoogleCaptchaV3Service',
    'PasswordValidationService',
    require('./competition-directive')
]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/index.js
 **/